<p>top-bar-action-events works!</p>
